import { SystemService } from "./SystemService";
import AuthService from "./AuthService";
import { saveAs } from 'file-saver';

class CheckInsService {
    systemService = null;
    api = null;
    authService = null;

    constructor() {
        this.systemService = new SystemService();
        this.authService = new AuthService();
        this.api = this.systemService.getApiAccess();
    }

    getCheckIns(params) {
        let sessionid = this.authService.getSessionId();
        let url = 'check-ins?';
        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
                url += `${key}=${params[key]}&`;
            }
        });
        return this.api.get(url, { headers: { authorization: sessionid } }).then(r => r.data);
    }

    getActiveCheckIns(wh) {
        let sessionid = this.authService.getSessionId();
        return this.api.get(`check-ins/active${wh ? `?wh=${wh}` : ''}`, { headers: { authorization: sessionid } }).then(r => r.data);
    }

    exportCheckIns(params) {
        let sessionid = this.authService.getSessionId();
        let url = 'check-ins/export?';
        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
                url += `${key}=${params[key]}&`;
            }
        });
        return this.api.get(url, { responseType: 'blob', headers: { authorization: sessionid } }).then(response => {
            const blob = new Blob([response.data], {
                type: response.headers['content-type'],
            });
            saveAs(blob, 'CheckIns.xlsx');
        });
    }

    syncUnsynced() {
        let sessionid = this.authService.getSessionId();
        return this.api.post('check-ins/sync-unsynced', {}, { headers: { authorization: sessionid } }).then(r => r.data);
    }
}

export default CheckInsService;
